<div class="tool-container">

	<ng-container [ngSwitch]="activeToolOption?.id">

		<ng-container *ngSwitchCase="'background'">
			<app-image-tool-background
				[activeAsset]="activeAsset"
				[tools]="activeToolOption?.tools"
				(setActiveAsset)="setActiveAsset.emit($event)"
				(setActiveVariations)="setActiveVariations.emit($event)"
			></app-image-tool-background>
		</ng-container>

		<ng-container *ngSwitchCase="'text-to-image'">
			<app-image-tool-image-generation
				[activeAsset]="activeAsset"
				[tools]="activeToolOption?.tools"
				[config]="config"
				(setActiveAsset)="setActiveAsset.emit($event)"
				(setActiveVariations)="setActiveVariations.emit($event)"
				(setLoadingMessage)="setLoadingMessage.emit($event)"
			></app-image-tool-image-generation>
		</ng-container>

		<ng-container *ngSwitchCase="'edit-image'">
			<app-image-tool-edit-with-ai
				[activeAsset]="activeAsset"
				[tools]="activeToolOption?.tools"
				[config]="config"
				(setActiveAsset)="setActiveAsset.emit($event)"
				(setActiveVariations)="setActiveVariations.emit($event)"
				(setLoadingMessage)="setLoadingMessage.emit($event)"
			></app-image-tool-edit-with-ai>
		</ng-container>

		<ng-container *ngSwitchCase="'target-crop'">
			<app-image-tool-crop
				[targetCropConfig]="config.targetCropConfig"
				[activeAsset]="activeAsset"
				(targetCropConfigChange)="setConfigValue({ targetCropConfig: $event })"
				(activeAssetChange)="setActiveAsset.emit($event)"
			></app-image-tool-crop>
		</ng-container>

	</ng-container>

</div>
